import Vue from 'vue';
import { enterListener, setTabAttributes } from './elementUtils';

Vue.directive('a11y-tab', {
  bind: (el) => {
    el.setAttribute('tabIndex', 0);
    el.enterListener = enterListener(el);
    el.addEventListener('keypress', el.enterListener);
  },
  inserted: (el, binding) => {
    setTabAttributes(el, binding.arg, binding.modifiers);
  },
  componentUpdated: (el, binding) => {
    setTabAttributes(el, binding.arg, binding.modifiers);
  },
  unbind: (el) => {
    el.removeEventListener('keypress', el.enterListener);
  },
});
